module.exports = __webpack_public_path__ + "static/media/4day@2x.0aabf974.png";